import { useTranslate } from "../../../language/i18n";
import styles from "./TextComponents.module.scss";

const DefaultItemText = () => {
  const translate = useTranslate();
  return <span className={styles.default}>({translate("DEFAULT")})</span>;
};

export { DefaultItemText };
